/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-05-05
 */
 import {Component} from 'vue-property-decorator'
 import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
 import override from "src/dectorators/override";
 import {ElseSnConfigDOI} from "./api/elseSnConfigApi";
 import ElseSnConfigService from "./service/elseSnConfigService";
 import './elseSnConfig.less';
 
 
 @Component({name: 'else-sn-config'})
 export default class ElseSnConfig extends BasicSearchPage<ElseSnConfigService, ElseSnConfigDOI.RowDataI, ElseSnConfigDOI.QueryRowDataParamsI> {
    @override
    renderHead(h) {
        return <div></div>
    }
     
    @override
    loadService () {
        this.service = new ElseSnConfigService(this)
    }
 }